module.exports = __webpack_public_path__ + "img/Flag_of_The_Gambia.6a98c59d.svg";